/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_4_TInputs */

const en_mk_tut_gl_4_t = /** @type {(inputs: Mk_Tut_Gl_4_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run`)
};

const id_mk_tut_gl_4_t = /** @type {(inputs: Mk_Tut_Gl_4_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run`)
};

/**
* | output |
* | --- |
* | "Run" |
*
* @param {Mk_Tut_Gl_4_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_4_t = /** @type {((inputs?: Mk_Tut_Gl_4_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_4_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_4_t(inputs)
	return en_mk_tut_gl_4_t(inputs)
});